export const LogscordFeatureGroups = [
    {
        eyebrowKey: "features.group.observe.eyebrow",
        titleKey: "features.group.observe.title",
        features: [
            {
                icon: "manage_search",
                titleKey: "features.search.title",
                descriptionKey: "features.search.description",
            },
            {
                icon: "timeline",
                titleKey: "features.timeline.title",
                descriptionKey: "features.timeline.description",
            },
            {
                icon: "account_tree",
                titleKey: "features.network.title",
                descriptionKey: "features.network.description",
            },
        ],
    },
    {
        eyebrowKey: "features.group.understand.eyebrow",
        titleKey: "features.group.understand.title",
        features: [
            {
                icon: "settings_voice",
                titleKey: "features.voice.title",
                descriptionKey: "features.voice.description",
            },
            {
                icon: "history",
                titleKey: "features.machine.title",
                descriptionKey: "features.machine.description",
            },
            {
                icon: "rule",
                titleKey: "features.sanctions.title",
                descriptionKey: "features.sanctions.description",
            },
        ],
    },
    {
        eyebrowKey: "features.group.prove.eyebrow",
        titleKey: "features.group.prove.title",
        features: [
            {
                icon: "dashboard_customize",
                titleKey: "features.dashboards.title",
                descriptionKey: "features.dashboards.description",
            },
            {
                icon: "ios_share",
                titleKey: "features.exports.title",
                descriptionKey: "features.exports.description",
            },
            {
                icon: "security",
                titleKey: "features.access.title",
                descriptionKey: "features.access.description",
            },
        ],
    },
];
//# sourceMappingURL=features.js.map